import React from "react";
import PropTypes from "prop-types";

import { ConfirmationDropdown, Header, useAssigneeOptions } from "./components";

export function UserSelector({
  title,
  placeholder,
  loading,
  users,
  forceEnabled,
  initSelectedUserId,
  onSelect,
  onChange,
  includeUnassignedOption,
  allowAdditions,
  forceSelectedUserId,
}) {
  const assigneeOptions = useAssigneeOptions(users);
  const options = assigneeOptions.concat(
    [
      includeUnassignedOption && {
        key: "unassigned",
        value: "unassigned",
        text: "Unassigned",
        icon: "user circle outline",
      },
      allowAdditions && {
        key: "add-user",
        value: "add-user",
        text: "Invite User",
        icon: "plus",
      },
    ].filter(Boolean)
  );

  return (
    <div style={{ width: "max-content" }}>
      <div style={{ display: "flex" }}>
        <Header as="h4" style={{ marginBottom: "1em" }}>
          {title}
        </Header>
      </div>
      <div>
        <ConfirmationDropdown
          data-dd-action-name={title}
          placeholder={placeholder}
          loading={loading}
          forceEnabled={forceEnabled}
          initValue={
            options.find(({ key }) => {
              return key === initSelectedUserId;
            })?.key || "unassigned"
          }
          onChange={(selectedKey) => {
            const u = users.find(({ id }) => {
              return id === selectedKey;
            });

            if (u) onChange(u);
            else
              onChange(
                selectedKey === "add-user" || selectedKey === "unassigned"
                  ? { id: selectedKey }
                  : { id: "add-user", name: selectedKey.trim() }
              );
          }}
          onSelect={(selectedKey) => {
            onSelect(
              users.find(({ id }) => {
                return id === selectedKey;
              }) || { id: "unassigned" }
            );
          }}
          items={options}
          allowAdditions={allowAdditions}
          forceSelectedValue={forceSelectedUserId}
        />
      </div>
    </div>
  );
}

UserSelector.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  initSelectedUserId: PropTypes.string,
  forceSelectedUserId: PropTypes.string,
  forceEnabled: PropTypes.bool,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      group: PropTypes.bool,
    })
  ).isRequired,
  includeUnassignedOption: PropTypes.bool,
  onChange: PropTypes.func,
  allowAdditions: PropTypes.bool,
};

UserSelector.defaultProps = {
  title: "Edit Team Member",
  placeholder: "Select a Team Member",
  initSelectedUserId: "unassigned",
  forceEnabled: false,
  loading: false,
  includeUnassignedOption: true,
  allowAdditions: false,
  onChange: () => {},
  forceSelectedUserId: null,
};

export default UserSelector;
